// extracted by mini-css-extract-plugin
export default {"flexEnd":"styles_flexEnd__xzrLs"};